const MDMS = new Map([
      ["TDMSE1001", "The device where this person exists is not currently online, please wait until it is online and go to the device details template to delete the person"],
      ["DMSE00621", "This device is not a registration device, registration is not allowed"],
      ["DMSE9999", "The cloud system is busy, please try this operation later"],
      
      ["TDMSE1002", "You have successfully removed the person from the device, but you encountered an error when deleting the person in the software, please retry the deletion operation"],
  ]);

export default MDMS
